import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="membership-form"
export default class extends Controller {
  static targets = ['groupIdContainer', 'groupIdInput', 'isAdminInput']

  connect() {
  }

  toggleGroupIdInput() {
    if (this.hasGroupIdContainerTarget && this.hasIsAdminInputTarget) {
      const isAdmin = this.isAdminInputTarget.checked;

      let groupIdInput = this.groupIdContainerTarget.querySelector('select');

      if(isAdmin){
        this.groupIdContainerTarget.classList.add('d-none');
        groupIdInput.value = null;
        groupIdInput.required = false;
      } else {
        this.groupIdContainerTarget.classList.remove('d-none');
        groupIdInput.value = null;
        groupIdInput.required = true;
      }
    }
  }
}
